import SimpleLayout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import {
  fetchGoalChannelTabs,
  fetchSinglePlaylistsInfinite
} from '@api/fetchers/youtube-course';
import useFullSingleYoutubeCourses from '@api/hooks/single-youtube-course/useFullSingleYoutubeCourses';
import { fetchGoalInfo } from '@api/fetchers/goal';
import { SWRConfig } from 'swr';
import SingleCoursePage from '@cont/YoutubeCourses/SingleCoursePage';

export const SingleYoutubeCoursePage = ({ goalUID, fallbackData }) => {
  const { keys } = useFullSingleYoutubeCourses(goalUID, fallbackData);
  const metaTitle = `Unacademy - ${fallbackData?.goalData?.name} - Free Courses`;
  return (
    <SWRConfig
      value={{
        revalidateOnMount: false,
        dedupingInterval: 60 * 1000,
        fallback: {
          [keys.youtubeChannelTabsSWRKey]: fallbackData?.channelTabsData,
          [keys.singleYoutubePlaylistsSWRKey]: [fallbackData?.singlePlaylists],
          [keys.goalInfoSWRKey]: fallbackData?.goalData
        }
      }}
    >
      <NextSeo
        title={metaTitle}
        openGraph={{
          title: metaTitle
        }}
      />
      <Head>
        <title>{metaTitle}</title>
      </Head>
      <SingleCoursePage goalUID={goalUID} />
    </SWRConfig>
  );
};

export const getStaticProps = async ({ params }) => {
  try {
    const { goalUID } = params || {};
    if (!goalUID) return { notFound: true };
    const singlePlaylistsData = await fetchSinglePlaylistsInfinite(goalUID);
    if (!singlePlaylistsData?.results?.length) {
      return { notFound: true, revalidate: 60 };
    }
    const goalData = await fetchGoalInfo(goalUID);
    const channelTabsData = await fetchGoalChannelTabs(goalUID);
    return {
      props: {
        fallbackData: {
          goalData,
          channelTabsData,
          singlePlaylists: singlePlaylistsData
        },
        goalUID
      }
    };
  } catch {
    return { notFound: true, revalidate: 60 };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

export default SingleYoutubeCoursePage;
SingleYoutubeCoursePage.Layout = SimpleLayout;
SingleYoutubeCoursePage.Wrapper = PageReduxProvider;
